const VIDEO_POSTER_DEFAULT = '/images/video-placeholder_black.png'

const TUTORIAL_POSTER = 'images/tutorial-poster.png'

export { VIDEO_POSTER_DEFAULT, TUTORIAL_POSTER }
